import { render } from "./MultipleChoiceType.vue?vue&type=template&id=4a6f39a4&scoped=true"
import script from "./MultipleChoiceType.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceType.vue?vue&type=script&lang=js"

import "./MultipleChoiceType.vue?vue&type=style&index=0&id=4a6f39a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6f39a4"]])

export default __exports__